import React, { memo, useEffect } from 'react'
import { useGeocodingSearch } from 'transfix-maps/hooks/useGeocodingSearch'
import { RelativeDateTime } from 'transfix-ui/components/RelativeDateTime'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { ILocationELD } from 'apps/fleet-planner/types'
import { Bullet } from 'components/atoms'
import { getTrackingMethodText } from '../utils'

export interface ISubtitleComponentLocationProps {
  /**
   * List of the last seen locations of truck
   * @default []
   */
  recentLocations?: ILocationELD[]
  /**
   * Adds a `Last Seen in` string to the front of Location text
   * @default false because it's usually live tracking
   */
  lastSeen?: boolean
}

/**  Used for the subtitle of "in_transit", "delivered", and "at pickup" ELD statuses
 * * @example "Last seen in New York, NY via KeepTruckin" */

export const SubtitleComponentLocation = memo<ISubtitleComponentLocationProps>(
  ({ recentLocations = [], lastSeen = false }) => {
    const [lastPing] = recentLocations || []
    const { latitude, locatedAt, locationSource, longitude } = lastPing || {}

    const sourceText = getTrackingMethodText(locationSource as TRACKING_METHOD_TYPE)
    const { results = [], getResults } = useGeocodingSearch()
    const [lastLocation] = results || []
    const { city, state } = lastLocation || {}

    /**
     * Grab the city and state information from Mapbox everytime the most recent location updates
     */
    useEffect(() => {
      if (longitude && latitude) {
        getResults('', { latitude: Number(latitude), longitude: Number(longitude) })
      }
    }, [getResults, latitude, longitude])

    return (
      <span>
        {lastSeen ? 'Last seen in ' : ''}
        {city}, {state} <Bullet /> <RelativeDateTime datetime={locatedAt} isShorthand /> via{' '}
        {sourceText}
      </span>
    )
  }
)

export default SubtitleComponentLocation
